module.exports = __webpack_public_path__ + "img/badge_services_gold.ce86e6d3.png";